import TochiShaderChunk from "./TochiShaderChunk";
import { FresnelChunk } from "./FresnelChunk";
import { mergeUniforms } from "three/src/renderers/shaders/UniformsUtils.js";
import { ShaderChunk } from "three";

export const SkinChunk: TochiShaderChunk = {
  name: "skin",
  uniforms: mergeUniforms([FresnelChunk.uniforms]),
  vertexShader: {
    premain: [
      "uniform vec4 offsetRepeat;",
      "varying vec3 vNormal;",
      "varying vec2 vUv;",
      "varying vec3 vViewPosition;",
      ShaderChunk["common"],
      ShaderChunk["lights_pars"],
      ShaderChunk["shadowmap_pars_vertex"],
      ShaderChunk["morphtarget_pars_vertex"],
      ShaderChunk["skinning_pars_vertex"],
      FresnelChunk.vertexShader.premain,
    ].join("\n"),
    main: [
      "vUv = uv;",
      "vec4 worldPosition = modelMatrix * vec4( position, 1.0 );",
      ShaderChunk["skinbase_vertex"],
      ShaderChunk["begin_vertex"],
      ShaderChunk["morphtarget_vertex"],
      ShaderChunk["skinning_vertex"],
      ShaderChunk["project_vertex"],
      ShaderChunk["beginnormal_vertex"],
      ShaderChunk["skinnormal_vertex"],
      "vViewPosition = -mvPosition.xyz;",
      // 'gl_Position = projectionMatrix * mvPosition;',
      ShaderChunk["shadowmap_vertex"],
      FresnelChunk.vertexShader.main,
    ].join("\n"),
  },
  fragmentShader: {
    premain: FresnelChunk.fragmentShader.premain,
    main: FresnelChunk.fragmentShader.main,
  },
};
